import React from "react"
import { DropdownButton } from "react-bootstrap"

import Routes from "@/routes"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import ButtonLink from "@/components/ButtonLink"

const ExportButtons = () => (
  <DropdownButton title="Exports">
    <ButtonLink
      label="Inventory Data"
      className="dropdown-item"
      button={false}
      href={Routes.data_exchange_exports_inventory_allocation_index_path({
        format: "csv",
      })}
    />
    <ButtonLink
      label="Sales Data"
      className="dropdown-item"
      button={false}
      href={Routes.data_exchange_exports_inventory_sales_path({
        format: "csv",
      })}
    />
    <CruiseLineOnly>
      <ButtonLink
        label="Tour Inventory Tracker"
        className="dropdown-item"
        button={false}
        href={Routes.data_exchange_exports_inventory_tracker_index_path({
          format: "csv",
        })}
      />
    </CruiseLineOnly>
  </DropdownButton>
)

export default ExportButtons
